var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Whatsapp-button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M0,0H18V18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M5.94,14.37l.543.317a6,6,0,1,0-2.17-2.17l.316.543-.49,1.8,1.8-.491ZM2,17l1.014-3.726a7.5,7.5,0,1,1,2.711,2.71ZM6.793,5.981a2.54,2.54,0,0,1,.3,0c.04,0,.081.007.121.012a.378.378,0,0,1,.295.187q.335.76.651,1.53a.455.455,0,0,1-.07.4,3.286,3.286,0,0,1-.2.279c-.085.109-.267.308-.267.308a.24.24,0,0,0-.046.2.664.664,0,0,0,.077.154l.044.071a4.751,4.751,0,0,0,.765.951c.09.087.178.176.272.26a4.507,4.507,0,0,0,1.178.75l0,0,.189.082a1.077,1.077,0,0,0,.143.049.263.263,0,0,0,.275-.1,8.758,8.758,0,0,1,.6-.7h0a.362.362,0,0,1,.284-.1.388.388,0,0,1,.133.03c.4.182,1.05.466,1.05.466l.437.2a.253.253,0,0,1,.142.2,1.448,1.448,0,0,1-.01.28,2.089,2.089,0,0,1-.141.55.866.866,0,0,1-.157.226,1.784,1.784,0,0,1-.248.216l-.094.067q-.14.089-.287.165a1.493,1.493,0,0,1-.625.173,3.867,3.867,0,0,1-.417.01l-.426-.065A7.086,7.086,0,0,1,7.887,11.3c-.17-.149-.326-.31-.487-.47A7.132,7.132,0,0,1,5.923,8.775a2.6,2.6,0,0,1-.248-1.06A2.047,2.047,0,0,1,6.1,6.455a1.774,1.774,0,0,1,.2-.229.955.955,0,0,1,.22-.171.721.721,0,0,1,.278-.075Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappButtonIcon);
export default __webpack_public_path__ + "static/media/Whatsapp-button-icon.3a319741b61fec6657c17deae0d2af33.svg";
export { ForwardRef as ReactComponent };